<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
    <page-title>Saved Applications</page-title>
    <!-- <search></search> -->
    <div class="has-background-white has-padding-left-30 has-padding-right-30 has-padding-bottom-15 has-padding-top-15">
      <h2
        class="is-size-5 has-text-weight-bold is-uppercase has-letter-spacing-3 is-black has-margin-bottom-10"
      >Saved Application Listings</h2>
      <saved-applications-table
        :shippingRequests="savedApplications"
        :isPaginated="isPaginated"
        :isPaginationSimple="isPaginationSimple"
        :defaultSortDirection="defaultSortDirection"
        :currentPage="currentPage"
        :perPage="perPage"
        savedShippingRequest
      ></saved-applications-table>
    </div>
  </div>
</template>

<script>
import Search from "@/modules/commonModule/layouts/Search";
import SavedApplicationsTable from "../components/MainTable";
import GetShippersSavedShippingRequests from "@/modules/shippersModule/api/graphql/queries/GetShippersSavedShippingRequests";
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapMutations } = createNamespacedHelpers("shippers");
import { SHIPPER_MUTATION_TYPES } from "@/store/mutation-types";

export default {
  components: { SavedApplicationsTable, Search },
  data() {
    return {
      isPaginated: true,
      isPaginationSimple: false,
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 25,
      userID: null,
      isLoading: false
    };
  },
  mounted() {
    this.userID = this.getUserID();
  },
  computed: {
    ...mapGetters({
      savedShippingRequests: "getSavedShippingRequests"
    }),
    savedApplications(){
      return this.savedShippingRequests.filter(shippingRequest => shippingRequest.form_details !== undefined)
    }
  },
  methods: {
    getUserID() {
      return this.$store.getters.getUserID;
    }
  }
};
</script>
